import { useRef } from 'react';

function TextEditor({ value, onChange, placeholder, rows = 5, label, readOnly = false, disabled = false }) {
  const textareaRef = useRef(null);

  const insertText = (before, after = '') => {
    if (readOnly || disabled) return;
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = value.substring(start, end);
    const newText = value.substring(0, start) + before + selectedText + after + value.substring(end);
    
    // Call onChange with the new text value directly
    if (typeof onChange === 'function') {
      onChange(newText);
    }
    
    // Restore cursor position
    setTimeout(() => {
      textarea.focus();
      const newCursorPos = start + before.length + selectedText.length + after.length;
      textarea.setSelectionRange(newCursorPos, newCursorPos);
    }, 0);
  };

  const makeBold = () => {
    insertText('**', '**');
  };

  const makeHeading = (level) => {
    const headingPrefix = '#'.repeat(level) + ' ';
    insertText(headingPrefix, '');
  };

  return (
    <div>
      {label && (
        <label className="form-label d-flex justify-content-between align-items-center">
          <span>{label}</span>
          <div className="btn-group btn-group-sm" role="group">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={makeBold}
              title="Bold (Ctrl+B)"
              onMouseDown={(e) => e.preventDefault()}
              disabled={readOnly || disabled}
            >
              <i className="bi bi-type-bold"></i>
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => makeHeading(1)}
              title="Heading 1"
              onMouseDown={(e) => e.preventDefault()}
              disabled={readOnly || disabled}
            >
              <i className="bi bi-type-h1"></i>
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => makeHeading(2)}
              title="Heading 2"
              onMouseDown={(e) => e.preventDefault()}
              disabled={readOnly || disabled}
            >
              <i className="bi bi-type-h2"></i>
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => makeHeading(3)}
              title="Heading 3"
              onMouseDown={(e) => e.preventDefault()}
              disabled={readOnly || disabled}
            >
              <i className="bi bi-type-h3"></i>
            </button>
          </div>
        </label>
      )}
      <textarea
        ref={textareaRef}
        className="form-control"
        rows={rows}
        value={value || ''}
        onChange={(e) => {
          const val = e?.target?.value || '';
          if (typeof onChange === 'function') {
            onChange(val);
          }
        }}
        placeholder={placeholder}
        readOnly={readOnly}
        disabled={disabled}
        onKeyDown={(e) => {
          if (readOnly || disabled) return;
          if (e.ctrlKey && e.key === 'b') {
            e.preventDefault();
            makeBold();
          }
        }}
      />
      <small className="text-muted">
        Tip: Select text and click Bold to make it bold. Use **text** for bold or # for headings.
      </small>
    </div>
  );
}

export default TextEditor;
